import React from 'react';
import "./company-partner.css";

import LinkedIn from "../../assets/company-partner/linkedin-logo-1.svg.svg";
import Uber from "../../assets/company-partner/uber-logo-1.svg.svg";
import Google from "../../assets/company-partner/google-logo-2.svg fill.svg";
import Intel from "../../assets/company-partner/intel.svg";
import Chubb from "../../assets/company-partner/chubb.svg";
import Ibm from "../../assets/company-partner/ibm.svg";
import Sk from "../../assets/company-partner/SK.svg.svg";
import bny from "../../assets/company-partner/bny-mellon-logo.svg.svg";

const CompanyPartner = () => {
    return (
        <section className="trusted-by-partners-section">
            <div className="container">
                <div className="trusted-by-partners-wrapper">
                    <h2>Trusted by leading companies and Partners</h2>
                    <div className="trusted-by-partners-images row">
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={LinkedIn} alt="linkedin" loading="lazy" width="101" height="60" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Uber} alt="uber" loading="lazy" width="140" height="27" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Google} alt="google" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Intel} alt="intel" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Chubb} alt="chubb" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Ibm} alt="ibm" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Sk} alt="sk" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={bny} alt="bny-mellon" loading="lazy" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={LinkedIn} alt="linkedin" loading="lazy" width="101" height="60" />
                        </div>
                        <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
                            <img src={Uber} alt="uber" loading="lazy" width="140" height="27" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyPartner;
